import React, { useEffect, useState } from "react";
import diamond from "../../images/diamond.svg";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { BarLoader } from "react-spinners";

export const Navbar = ({ tokens = [] }) => {
  const [index, setIndex] = useState(0);
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    if (!tokens.length) return;

    const interval = setInterval(() => {
      setAnimate(false); // start exit animation

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % tokens.length);
        setAnimate(true); // enter animation
      }, 300);
    }, 3000);

    return () => clearInterval(interval);
  }, [tokens]);

  const token = tokens[index];

  return (
    <div className="flex flex-col px-4 py-4 border-b border-gray-900  w-full items-center">
      <div className="w-full flex justify-between items-center px- overflow-hidden">
        {/* TOKEN SLIDER */}
        <div className="relative h-8 w-8/12 overflow-hidden">
          {tokens.length ? (
            <div className="flex flex-col justify-start items-start">
              {" "}
              <div
                className={`
                 flex items-center justify-start gap-1
                transition-all duration-300 ease-in-out
                ${
                  animate
                    ? "translate-y-0 opacity-100"
                    : "-translate-y-6 opacity-0"
                }
              `}
              >
                <img
                  src={token.image}
                  alt={token.name}
                  className="w-6 h-6 rounded-full"
                />

                <span className="text-sm  text-gray-100 font-bold text-normal uppercase">
                  {token.symbol}
                </span>

                <span
                  style={{ fontSize: "10px" }}
                  className="text-xs font-medium text-gray-200"
                >
                  ${token.current_price}
                </span>

                <div
                  style={{ fontSize: "10px" }}
                  className={`flex items-center text-xs font-bold pulse ${
                    token.price_change_percentage_24h < 0
                      ? "text-red-500"
                      : "text-green-500"
                  }`}
                >
                  {token.price_change_percentage_24h < 0 ? (
                    <IoMdArrowDropdown className="text-lg" />
                  ) : (
                    <IoMdArrowDropup className="text-lg" />
                  )}
                  {Math.abs(token.price_change_percentage_24h).toFixed(2)}%
                </div>
              </div>
            </div>
          ) : (
            <div className=" h-full flex items-center">
              <BarLoader color="#debd16" />
            </div>
          )}
          <div className="google-translate-wrapper fixed opacity-50 right-0"></div>
        </div>
        {/* RIGHT ICON */}{" "}
        <div className="flex flex-col justify-end items-center mb-2">
          <img src={diamond} alt="diamond" />
        </div>
      </div>
    </div>
  );
};
